var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrollment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-enrollment",
    transform: "translate(1736 2575)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_584",
    "data-name": "Ellipse 584",
    cx: 132,
    cy: 132,
    r: 132,
    transform: "translate(-1736 -2575)",
    fill: "#b8bfbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463",
    transform: "translate(-1676.273 -2518.77)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M543.774,1735.469l.041,128.237c0,3.151-2.163,5.852-5.313,5.852l-127.484.041a5.758,5.758,0,0,1-5.62-5.849l-.041-128.237a5.609,5.609,0,0,1,5.616-5.682l127.484-.04A5.363,5.363,0,0,1,543.774,1735.469Z",
    transform: "translate(-399.953 -1718.765)",
    fill: "#dae0de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M543.33,1735.469l.009,27.524-38.11-29.888-100.5,2.414a5.776,5.776,0,0,1,5.805-5.687l127.484-.04A5.363,5.363,0,0,1,543.33,1735.469Z",
    transform: "translate(-399.509 -1718.765)",
    fill: "#69c147",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M525.689,1713.242l.041,128.237a5.486,5.486,0,0,1-5.661,5.488l-127.484.041a5.165,5.165,0,0,1-5.272-5.485l-.041-128.237c0-3.151,2.118-6.045,5.269-6.046l127.484-.04A5.969,5.969,0,0,1,525.689,1713.242Z",
    transform: "translate(-387.272 -1702.924)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M525.689,1713.242l.009,29.742-138.417.044-.01-29.742c0-3.151,2.118-6.045,5.269-6.046l127.484-.04A5.969,5.969,0,0,1,525.689,1713.242Z",
    transform: "translate(-387.272 -1702.924)",
    fill: "#69c147"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6169",
    "data-name": "Rectangle 6169",
    width: 18.204,
    height: 16.287,
    transform: "translate(18.343 59.837)",
    fill: "#43474c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6170",
    "data-name": "Rectangle 6170",
    width: 18.204,
    height: 16.287,
    transform: "translate(46.606 59.828)",
    fill: "#43474c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6171",
    "data-name": "Rectangle 6171",
    width: 18.204,
    height: 16.287,
    transform: "translate(74.87 59.819)",
    fill: "#43474c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6172",
    "data-name": "Rectangle 6172",
    width: 18.204,
    height: 16.287,
    transform: "translate(103.133 59.81)",
    fill: "#43474c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6173",
    "data-name": "Rectangle 6173",
    width: 18.204,
    height: 16.287,
    transform: "translate(18.351 84.268)",
    fill: "#43474c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6174",
    "data-name": "Rectangle 6174",
    width: 18.204,
    height: 16.287,
    transform: "translate(46.614 84.259)",
    fill: "#43474c"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6175",
    "data-name": "Rectangle 6175",
    width: 18.204,
    height: 16.287,
    transform: "translate(74.877 84.25)",
    fill: "#43474c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6176",
    "data-name": "Rectangle 6176",
    width: 18.204,
    height: 16.287,
    transform: "translate(103.141 84.241)",
    fill: "#43474c"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6177",
    "data-name": "Rectangle 6177",
    width: 18.204,
    height: 16.287,
    transform: "translate(18.358 107.359)",
    fill: "#43474c"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6178",
    "data-name": "Rectangle 6178",
    width: 18.204,
    height: 16.287,
    transform: "translate(46.621 107.349)",
    fill: "#43474c"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6179",
    "data-name": "Rectangle 6179",
    width: 18.204,
    height: 16.287,
    transform: "translate(74.885 107.341)",
    fill: "#43474c"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6180",
    "data-name": "Rectangle 6180",
    width: 18.204,
    height: 16.287,
    transform: "translate(102.567 107.332)",
    fill: "#43474c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M488.419,1769.033a5.323,5.323,0,1,1-5.324-5.321A5.323,5.323,0,0,1,488.419,1769.033Z",
    transform: "translate(-450.731 -1742.55)",
    fill: "#b8bfbd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M721.391,1768.959a5.323,5.323,0,1,1-5.324-5.321A5.323,5.323,0,0,1,721.391,1768.959Z",
    transform: "translate(-614.089 -1742.498)",
    fill: "#b8bfbd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M481.724,1695.483a1.637,1.637,0,0,1,2.323.021,5.546,5.546,0,0,1,1.147,2.1h.586a8.247,8.247,0,0,0-1.137-2.96,3.8,3.8,0,0,0-4.391-1.474,7.633,7.633,0,0,0-3.93,3.142,10,10,0,0,0-1.616,4.837c-.246,3.486-.2,11.284,4.373,16.152l4.791,0S473.724,1703.35,481.724,1695.483Z",
    transform: "translate(-448.524 -1692.943)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M716.121,1695.409a1.637,1.637,0,0,1,2.323.021,5.55,5.55,0,0,1,1.147,2.1h.585a8.245,8.245,0,0,0-1.137-2.96,3.8,3.8,0,0,0-4.39-1.474,7.635,7.635,0,0,0-3.931,3.142,10.007,10.007,0,0,0-1.616,4.837c-.246,3.486-.2,11.283,4.373,16.152h4.791S708.121,1703.276,716.121,1695.409Z",
    transform: "translate(-612.882 -1692.891)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollment);
export default __webpack_public_path__ + "static/media/enrollment.268515a81a13f8021b1efeb4289e866e.svg";
export { ForwardRef as ReactComponent };